import { getToken } from "../system";
import { EMPTY_STRING } from "../constants/global.constants";

//Function for jwt token authorization header
export function authHeader() {
  //Return authorization header with jwt token
  const payload = getToken();

  const userToken = payload || EMPTY_STRING;
  if (userToken && userToken.length > 0) {
    return {
      Authorization: `Bearer ${userToken}`,
    };
  }
  return {};
}
